<template>
  <div class="cat-input" >
    <!-- type：先判断是否有传入显示密码，控制输入框类型是文本/密码，然后是type传入的值 -->
    <input
      :type="showPassword ? (passwordVisiable ? 'text' : 'password') : type"
      class="cat-input__inner"
      :placeholder="placeholder"
      :name="name"
      :disabled="disabled"
      :class="{ 'is-disabled': disabled }"
      :value="value"
      @input="handleinput"
      @blur="blurinput"
    />
    <!-- <div v-if="testtextbool">{{showtel}}</div> -->
    <!-- :class="rtest=='发送验证码'?'cat-input__rtest':'cat-input__rtescode'"  -->
    <!-- :class="testtextbool?'cat-input__rtescode':'cat-input__rtest'" -->

    
    <span class="sendcodew" @click="testclick" :class="testtextbool?'cat-input__rtescode':'cat-input__rtest'"  v-if="rtest&&rtest=='发送验证码'">
        {{rtest=='发送验证码'?rtest:rtest+'s'}}
    </span>

    <!-- testtextbool? -->
     <span class="sendcoded" @click="testclick" :class="'cat-input__rtescode'"   v-if="rtest&&rtest!='发送验证码'">
        {{rtest+'s'}}
    </span>

   
  </div>
</template>
 
<script>
export default {
  name: "CatInput",
  props: {
    time:60,
    showtel:{
    type: String,
    default: "",
    },
    testtextbool:{
 type: Boolean,
   default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    rtest:{
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    number:{
   type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    showPassword: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      passwordVisiable: false, //控制是否显示密码
    };
  },

  mounted(){
  
   
if(this.value.trim().length==0){
   
if(this.rtest=='发送验证码'){
  document.getElementsByClassName('cat-input__rtest')[0].style.color='rgba(153,153,153,1)'
  //  console.log(document.getElementsByClassName('sendcodew')[0].style.color='red')
}
  
// document.getElementById('sendcode').style.color='red'
}
  },
  methods: {
    blurinput(){
this.$emit('bluript')
    },
    testclick(){
   setTimeout(()=>{

   

   })

   
      
this.$emit('codeclick')
    },
    handleinput(event) {
    if(this.number=='11'){
   if((event.target.value).trim().length!=11||Number(event.target.value)=='NaN'){
        var telreg= /^1[0-9]{10}$/.test(event.target.value)
     if(!telreg){
 this.$emit(`update:testtextbool`, true)
 document.getElementsByClassName('sendcodew')[0].style.color='rgba(153,153,153,1)'
     }
       
  // document.getElementById('sendcode').style.color='rgba(153,153,153,1)'
 
  // document.getElementById('sendcode').addClass('cat-input__rtescode')
  // this.$refs.sendcode.className=''
  // this.$refs.sendcode.addClass('cat-input__rtescode')
 
      }else{
         this.$emit(`update:testtextbool`, false)
   document.getElementsByClassName('sendcodew')[0].style.color='#54B0FB'
          //  document.getElementById('sendcode').className='cat-input__rtes'
  // document.getElementById('sendcode').addClass('cat-input__rtes')
          //  this.$refs.sendcode.className=''
  // this.$refs.sendcode.addClass('cat-input__rtest')
      }
    } 
 
       if(this.number=='1'){
      
 if((event.target.value).trim().length!=4){
  
        this.$emit(`update:testtextbool`, true)
      }else{
         this.$emit(`update:testtextbool`, false)
            
      }
       }
   
      this.$emit("input", event.target.value);
    
    },
    clear() {
      this.$emit("input", "");
    },
    handlepwd() {
      this.passwordVisiable = !this.passwordVisiable;
    },
  },
  computed: {
    //有清空/显示密码，添加类名、显示span
    showSuffix() {
      return this.clearable || this.showPassword;
    },
  },
};
</script>
<style lang="less" scoped>
// 兼容写法  .cat-input 是父级class
.cat-input input::-webkit-input-placeholder { 
/* WebKit browsers */ 
color: @graycolor; 
} 
.cat-input input:-moz-placeholder { 
/* Mozilla Firefox 4 to 18 */ 
color: @graycolor; 
} 
.cat-input input::-moz-placeholder { 
/* Mozilla Firefox 19+ */ 
color: @graycolor; 
} 
.cat-input input:-ms-input-placeholder { 
/* Internet Explorer 10+ */ 
color: @graycolor; 
}

.cat-input__inner{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  border-radius: 2px;
  border: @allboxborder;
  padding: @inputpadding;
 
 
    
}
.cat-input{
    position: relative;
}
.cat-input__rtescode{
  position: absolute;
    right: @padingbox;
    top: 50%;
    color: @graycolor;
    transform: translateY(-50%);
}
.cat-input__rtest{
      position: absolute;
    right: @padingbox;
    top: 50%;
    color: @bluebtn;
    transform: translateY(-50%); 
  
}



</style>